/* eslint-disable max-classes-per-file */
import { KartgeometriDTO } from "~app/common/models/karta/KartgeometriDTO";
import { VKDirektutbyteTradslagDTO } from "~app/features/virkeskop/models/tradslag/direktutbyte-models";

export interface IKartgeometriSubtyp {
    subtyp1: string;
    subtyp2: string;
    subtyp3: string;
}

export class KartgeometriSubtyp implements IKartgeometriSubtyp {

    constructor(public subtyp1: string, public subtyp2: string, public subtyp3: string) {

    }
    isOfSameSubtyp = (other: IKartgeometriSubtyp): boolean => this.subtyp1 === other.subtyp1 && this.subtyp2 === other.subtyp2 && this.subtyp3 === other.subtyp3;
    isOfMixSubtyp = (other: IKartgeometriSubtyp): boolean => other.subtyp2 === "Avlägg & Larmpunkt";
}

export class Kartgeometrier {
// eslint-disable-next-line sonarjs/public-static-readonly
    static drivningspunktAvlagg: KartgeometriSubtyp = new KartgeometriSubtyp("Drivningspunkt", "Avlägg", null);
    // eslint-disable-next-line sonarjs/public-static-readonly
    static drivningspunktOvrigLarmpunkt: KartgeometriSubtyp = new KartgeometriSubtyp("Drivningspunkt", "Övrig drivningspunkt", "Larmpunkt");
    // eslint-disable-next-line sonarjs/public-static-readonly
    static drivningspunktOvrigKojplats: KartgeometriSubtyp = new KartgeometriSubtyp("Drivningspunkt", "Övrig drivningspunkt", "Kojplats");
}

// En specialhjälpklass som gör så att vi kan validera drivningspunkterna innan de skickas till backend
// De övriga valideringshjälpklasserna validerar sparade drivningspunkter vilket gör att man kan hamna i ett moment 22
// Detta pga att man inte kan spara drivningspunkterna för att någon annan regel anser att de inte är godkända
// För att köra denna i kombinerad kompabilitet (backend och frontend) så måste remapFromBackEndModel köras först
export class KartgeometrierOsparadeDrivningspunkterValidering {
// eslint-disable-next-line sonarjs/public-static-readonly
    static isAvlagg = (drivningspunkt: KartgeometriDTO) => drivningspunkt.subtyp1 === "Drivningspunkt" && drivningspunkt.subtyp2 === "Avlägg";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static isKojplats = (drivningspunkt: KartgeometriDTO) => drivningspunkt.subtyp1 === "Drivningspunkt" && drivningspunkt.subtyp2 === "Kojplats";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static isLarmpunkt = (drivningspunkt: KartgeometriDTO) => drivningspunkt.subtyp1 === "Drivningspunkt" && drivningspunkt.subtyp2 === "Larmpunkt";
}

export interface IKartgeometri extends IKartgeometriSubtyp {
    id: number;
    geometri: string;
    subtyp1: string;
    subtyp2: string;
    subtyp3: string;
    etikett: string;
    anteckning: string;
    rotation: number;
    tillganglighetsklass: string;
    langd: number;
    hansynAtgardTyp: string;
    karttext: string;
    isNew: boolean;
    offsetInMeters: number;
    isEditing: boolean;
    persistedKartgeometri?: IKartgeometri;
    guid: string;
    barighet?: number;
    ytstruktur?: number;
    lutning?: number;
    importkalla: string;
    externNyckel: string;
    direktutbyteTradslag?: VKDirektutbyteTradslagDTO[];
}

export class Kartgeometri implements IKartgeometri {
    id: number;
    geometri: string;
    subtyp1: string;
    subtyp2: string;
    subtyp3: string;
    etikett: string;
    anteckning: string;
    rotation: number;
    tillganglighetsklass: string;
    langd: number;
    hansynAtgardTyp: string;
    karttext: string;
    isNew: boolean;
    offsetInMeters: number;
    isEditing: boolean;
    persistedKartgeometri?: IKartgeometri;
    guid: string;
    barighet?: number;
    ytstruktur?: number;
    lutning?: number;
    importkalla: string;
    externNyckel: string;
    direktutbyteTradslag?: VKDirektutbyteTradslagDTO[];

    constructor(
        subtyp1: string,
        subtyp2?: string,
        subtyp3?: string,
        anteckning?: string,
        geometri?: string,
        isNew?: boolean,
        tillganglighetsklass?: string,
        hansynAtgardTyp?: string,
        karttext?: string,
        etikett?: string
    ) {
        this.subtyp1 = subtyp1;
        this.subtyp2 = subtyp2;
        this.subtyp3 = subtyp3;
        this.anteckning = anteckning;
        this.geometri = geometri;
        this.tillganglighetsklass = tillganglighetsklass;
        this.hansynAtgardTyp = hansynAtgardTyp;
        this.isNew = !!isNew;
        this.karttext = karttext;
        this.etikett = etikett;
    }
}

export interface ISubyper {
    namn: string;
    typer: string[];
    standardvarde: string;
}

export interface IKartgeometriBasdataRequest {
    kartgeometrityp: string;
    kategori: string;
    leveransvirke: boolean;
}

export interface IKartgeometriBasdataResponse {
    subtyp1: string;
    subtyper2: string[];
    subtyper3: ISubyper[];
    tillganglighetsklasser: string[];
}
